<template>
  <div id="app">
    <el-container>
      <el-header class="flex flex-mid" direction="horizontal">
        <i style="font-size: 36px;color: #409EFF;">智能电表</i>
        <div class="flex-1"></div>


        <head-image size="40" radius="50%"></head-image>
        <div class="ml-20">
          <el-dropdown trigger="click">
            <span class="el-dropdown-link">
              {{$store.state.LoginUser.userType == 0?'用户':'管理员'}}：
              {{$store.state.LoginUser.passport}}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!--<el-dropdown-item @click.native="">消息</el-dropdown-item>-->
              <el-dropdown-item @click.native="logout">退出登陆</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>

        <div class="notice flex flex-mid flex-center" @click="showNotice">
          <img src="../../assets/images/notice.png" alt="" class="notice">
          <div class="noticeNum" v-if="num">{{num}}</div>
        </div>
      </el-header>
      <el-container>
        <el-aside width="265px">
          <el-col :span="24">
            <el-menu
              :default-active="$store.state.currentPath"
              class="el-menu-vertical-demo"
              :unique-opened="true"
              background-color="#545c64"
              text-color="#fff"
              :router="true"
            ><!--active-text-color="#ffd04b"-->
              <el-menu-item index="/user/info">
                <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>个人信息</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/user/exchange">
                <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>充值记录</span>
                </template>
              </el-menu-item>
              <el-menu-item index="/user/electric">
                <template slot="title">
                  <i class="el-icon-location"></i>
                  <span>用电明细</span>
                </template>
              </el-menu-item>
              <!--<el-menu-item index="/user/notice">-->
                <!--<template slot="title">-->
                  <!--<i class="el-icon-location"></i>-->
                  <!--<span>消息</span>-->
                <!--</template>-->
              <!--</el-menu-item>-->
            </el-menu>
          </el-col>
        </el-aside>
        <div class="smart-main">
          <el-main>
            <router-view/>
          </el-main>
        </div>
      </el-container>
    </el-container>
    <form-dialog title="消息" :show-close="false" :show-confirm="false" ref="model" width="650px">
      <div slot="dialog-main" >
        <chat></chat>
      </div>
    </form-dialog>
  </div>
</template>

<script>
  import HeadImage from "../../components/HeadImage";
  import Message from "../../components/Message";
  import FormDialog from "../../components/FormDialog";
  import Chat from "../../components/Chat";
  export default {
    components: {
      Chat,
      FormDialog,
      Message,
      HeadImage
    },
    name: 'App',
    data(){
      return {
        form: {},
        dept: {},
        emp: {},
        num:'',
        messages :[]
      }
    },
    beforeMount(){
      let login = this.$checkLogin()
      this.$store.commit('setLoginUser', login)

    },
    mounted(){
      this.$store.commit('setCurrentPath', this.$route.path)
      this.getNotice()
//      this.getDeptTree()
    },
    methods: {
      logout(){
          this.$setCookie('METER_LOGIN_USER', '', -1)
          window.location.href = 'login.html'
      },
      getNotice(){
          this.$http$({url:'/smartMeterServer/message/userCount/'+this.$store.state.LoginUser.userId,method:'get'}, (data) => {
              this.num = data
          })
      },
      showNotice(){
        this.$refs.model.show()
      }
    }
  }
</script>

<style>
  .el-submenu__title i {
    color: #fff
  }

  .el-header {
    background: #333;
    color: #fff;
    position: absolute;
    width: 100%;
    height: 60px;
    left: 0;
    top: 0;
    min-width: 1450px;
  }

  .el-aside {
    position: absolute;
    top: 60px;
    left: 0px;
    width: 265px;
    bottom: 0px;
    background: rgb(84, 92, 100);
    overflow-y: scroll;
  }

  .el-menu {
    border-right: none;
  }

  .el-dropdown-menu {
    min-width: 100px;
  }

  .smart-main {
    position: absolute;
    top: 60px;
    left: 250px;
    right: 0px;
    bottom: 0px;
    background: #fff;
    z-index: auto;
    overflow-y: auto;
    min-width: 1200px;

  }

  .el-dropdown {
    height: 50px;
    line-height: 50px;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/entrance/index/UserIndex.vue